import { LocationModelDto } from '@treasury/api/channel';

export const defaultLocationModelDto: LocationModelDto = {
    isEnabled: true,
    locationNumber: undefined,
    name: undefined,
    locationReference: undefined,
};
